import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';

import * as toastr from 'toastr';
import {Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {LoaderService} from '../../app/general-services/service-loader/loader.service';
import {tap} from 'rxjs/operators';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService, public router: Router, private loaderService: LoaderService) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 0 || err.status === 401) {
          this.loaderService.display(false);
          toastr.warning('Session expired, try to Login again', 'Warning');
          this.router.navigate(['login']);
          // redirect to the login route
          // or show a modal
        }
      }
    }));
  }
}
